import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../index.css";
import {
  FacebookColorIcon,
  FacebookIcon,
  GoogleIcon,
  OutlinedFacebookIcon,
  OutlinedGoogleIcon,
} from "../../../icons";
import {
  getCurrentUser,
  selectAuth,
  signIn,
  signInWithGoogle,
  signInWithFacebook,
} from "../../../../features/auth/authSlice";
import Button from "../../../Button";
import { OutlinedInput } from "../../../Input";
import Menu from "../../Menu";
import { useLocation, useNavigate } from "react-router-dom";

const SignInMenu = ({
  onSignUpClick,
  setShowForgotModal,
  closeModal,
  setIsOpen,
  isOpen,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let location = useLocation();

  const [signInState, setSignInState] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    dispatch(getCurrentUser());
  }, [dispatch]);

  const user = useSelector(selectAuth);

  const handleGoogleSignIn = async () => {
    dispatch(
      signInWithGoogle({
        onSuccess: () => {
          if (location.pathname === "/") {
            navigate("/dashboard");
          }
        },
      })
    );
  }

  const handleFacebookSignIn = async () => {
    dispatch(
      signInWithFacebook({
        onSuccess: () => {
          if (location.pathname === "/") {
            navigate("/dashboard");
          }
        },
      })
    );
  }

  const handleSignIn = async () => {
    console.log("email", signInState.email);
    console.log("password", signInState.password);
    dispatch(
      signIn({
        email: signInState.email,
        password: signInState.password,
        onSuccess: () => {
          if (location.pathname === "/") {
            navigate("/dashboard");
          }
        },
      })
    );
  };

  const handleInputChange = (e) =>
    setSignInState({ ...signInState, [e.target.name]: e.target.value });

  return (
    <Menu setIsOpen={setIsOpen} isOpen={isOpen} onOverlayClick={closeModal}>
      <div className="auth-section container">

        <h2>Login to account</h2>

        <div className="auth-btn-group">
          <button className={"auth-btn"} onClick={() => {
            handleGoogleSignIn();
          }}>
            <GoogleIcon className={"auth-icon"} />
            Log in with Google
          </button>
          {/* <button className={"auth-btn"} onClick={() => {
            handleFacebookSignIn();
            }}>
            <FacebookColorIcon className={"auth-icon"} />
            Facebook
            </button> */}
        </div>

        <div className="or-text">OR</div>

        <form
          className="auth-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSignIn();
          }}
        >
          <OutlinedInput
            onChange={handleInputChange}
            name="email"
            // title="Email/Username"
            placeholder="Email/Username"
            value={signInState.email}
            required
          />
          <OutlinedInput
            onChange={handleInputChange}
            name="password"
            // title="Password"
            placeholder="Password"
            value={signInState.password}
            type="password"
            required
            minLength={6}
          />
          <span
            onClick={() => {
              closeModal();
              setShowForgotModal(true);
            }}
            className="pointer forgot-pass-span"
          >
            Forgot password?
          </span>
          <div className={"auth-sign-wrapper"}>
            <button type="submit" className={"auth-sign-btn pointer"}>
              Sign in
            </button>
          </div>
        </form>
        <span className="create-account">
          New User?&nbsp;
          <span
            onClick={() => {
              closeModal();
              onSignUpClick();
            }}
            className="pointer"
          >
            <strong>Create an account</strong>
          </span>
        </span>

      </div>
    </Menu>
  );
};

export default SignInMenu;
